<div class="td-wb-learn-saved-video__container"
     tdWbDataAnalyticsTagging
     [eventSignal]="eventData">
  <td-wb-card class="td-wb-learn-saved-video__card"
              [id]="uniqueId">
    <td-wb-image-placeholder [aspectRatio]="aspectRatio">
      <div class="td-wb-learn-saved-video__image">
        <img tdWbCardMedia
             aria-hidden="true"
             tdWbDefaultImage
             [alt]="lesson.imageUrl"
             [src]="lesson.imageUrl">
      </div>
      <td-wb-learn-duration [duration]="lesson.duration"
                            [timeRemaining]="lesson.timeRemaining"></td-wb-learn-duration>
    </td-wb-image-placeholder>
    <td-wb-card-content class="td-wb-learn-saved-video__card-content">
      @if (lesson.title !== undefined) {
        <div
          class="td-wb-learn-saved-video__content">
          <td-wb-card-subtitle class="td-wb-learn-saved-video__card-subtitle"
                               translate="tdWb.learn.welcome.mostLiked.INFO_LESSON_SUBTITLE">
          </td-wb-card-subtitle>
          <td-wb-card-title [attr.id]="uniqueId + 'aria'"
                            [innerText]="lesson.title"></td-wb-card-title>
        </div>
      }
    </td-wb-card-content>

    <td-wb-card-footer>
      <div class="td-wb-learn-saved-video__card-footer">
        @if (lesson.createdDate !== undefined) {
          <div>
            <td-wb-icon class="td-wb-learn-saved-video__card-icon"
                        iconId="calendar-alt--small"
                        [inline]="true"></td-wb-icon>
            <span [translate]="lesson.createdDate | tdWbDate"></span>
          </div>
        }
        @if (lesson.knowledgeLevel !== undefined) {
          <div class="td-wb-learn-saved-video__card-knowledge-level">
            <td-wb-icon class="td-wb-learn-saved-video__card-icon"
                        iconId="graduation-cap--small"
                        [inline]="true"></td-wb-icon>
            <span [innerText]="lesson.knowledgeLevel"></span>
          </div>
        } @else {
          <span>&nbsp;</span>
        }
      </div>
    </td-wb-card-footer>
    <td-wb-card-primary-action [attr.aria-labelledby]="uniqueId + 'aria'"
                               (action)="selectLesson()" />
  </td-wb-card>
  <div class="td-wb-learn-saved-video__action">
    <button [attr.id]="bookmarkUniqueId"
            class="td-wb-learn-saved-video__save"
            tdWbButton
            tdWbButtonType="icon"
            tdWbButtonSize="inline"
            tdWbBlock="spinningWheel"
            [attr.aria-label]="((lesson.saved ? 'tdWb.learn.UNSAVE_LESSON' : 'tdWb.learn.SAVE_LESSON') | tdWbTranslate) + ' - ' + lesson.title"
            [disabled]="saveDisabled"
            (click)="toggleSave($event)">
      <td-wb-icon [iconId]="lesson.saved ? 'bookmark-solid--small' : 'bookmark-outlined--small'"
                  [inline]="true"
                  size="18"></td-wb-icon>
    </button>
  </div>
</div>

